import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../../../components/AuthContext/context';
import { SsoLayout } from '../components/SsoLayout';
import { EMAIL_FIELD, type FormValues, LoginForm, PASSWORD_FIELD, validationSchema } from './LoginForm';

const initialValues: FormValues = {
  [EMAIL_FIELD]: '',
  [PASSWORD_FIELD]: '',
};

export function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { signInWithEmailAndPassword } = useAuth();

  const formMethods = useForm<FormValues>({
    defaultValues: initialValues,
    mode: 'all',
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = useCallback(
    async (values: FormValues): Promise<void> => {
      try {
        await signInWithEmailAndPassword(values[EMAIL_FIELD], values[PASSWORD_FIELD]);
      } catch (error) {
        if (error instanceof Error) {
          enqueueSnackbar(error.message, { variant: 'error' });
        }
      }
    },
    [enqueueSnackbar, signInWithEmailAndPassword]
  );

  const onForgotPasswordHandler = useCallback(
    () => navigate(`/forgot-password${location.search}${location.hash}`),
    [location, navigate]
  );

  return (
    <SsoLayout>
      <FormProvider {...formMethods}>
        <LoginForm onSubmitHandler={formMethods.handleSubmit(onSubmit)} onForgotPassword={onForgotPasswordHandler} />
      </FormProvider>
    </SsoLayout>
  );
}
